import ManageChirurgie from '@/views/parametres/configs/param-chirurgies/manage-chirurgie'
import ExcelModal from '@/views/parametres/import-excel-modal'
import $ from 'jquery'

export default {
    name: 'param-chirurgies',
    components: {
        ManageChirurgie, ExcelModal
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,

            fields: [
				{ key: 'chirurgie', label: 'Libellé' }, { key: 'k_chirurgie', label: 'K-Chirurgie' }, 
                { key: 'actions', label: 'Action.s' }
			],
			filter: "",
			perPage: 20,
			currentPage: 1,

            is_edit: false,

            save_loading: false,
            modal_title: 'Nouvelle chirurgie',
            exist_error: false,

            to_be_deleted: {
				id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,

            chirurgie_to_edit: {},

            is_printing: false,
            filename: '',

            modal_toggler: true,

            type_admission: '',
            designation: '',
            emit_action: '',

            chirurgie_fields: {
                'Chirurgie': 'chirurgie',
                'K-Chirurgie': 'k_chirurgie',
                'Prix': 'prix',
            },

            chirurgie_data: [],
            chirurgie_filename: 'Liste_Chirurgies.xls'
        }
    },

    computed: {
        liste_chirurgies() {
            return this.$store.getters["liste_chirurgies"];
        },

        rows() {
            return this.liste_chirurgies.length;
        },
    },

    mounted() {
        this.getListeChirurgies()

        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_chirurgies_'+tmpstamp
    },

    methods: {
        addPrestation() {
            this.modal_title = 'Nouvelle chirurgie'
            this.modal_toggler = (this.modal_toggler)?false:true
        },

        getListeChirurgies() {
            this.is_loading = true

            this.$store.dispatch('getListeChirurgies').then(() => {
                if (this.liste_chirurgies.length > 0) {
                    this.is_empty = false

                    this.liste_chirurgies.forEach(chirurgie => {
                        chirurgie.kchirurgies.forEach(kchirurgie => {
                            this.chirurgie_data.push({
                                'chirurgie': chirurgie.chirurgie, 
                                'k_chirurgie' : kchirurgie.k_chirurgie,
                                'prix' : (kchirurgie.pu > 0)?kchirurgie.pu:''
                            })
                        });
                    });
                } else {
                    this.is_empty = true
                }

                this.is_loading = false
            })
        },

        edit(chirurgie) {
            this.modal_title = 'Modifier'
            this.chirurgie_to_edit = chirurgie
            this.modal_toggler = (this.modal_toggler)?false:true
        },

        setToDelete(c) {
            this.to_be_deleted = {
                id: c.chirurgie_id,
                chirurgie: c.chirurgie
            }
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            this.$store.dispatch('deleteItem', this.to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast("Chirurgie supprimée avec succès")
                    this.getListeChirurgies()

                    this.is_confirm = false
                    this.$refs.chirurgieDelModal.click();
                }
                this.del_loading = false
            }).catch((err) => {
                console.log("ERROR CATCH: ", err)
                this.del_loading = false
            })
        },

        handleBeforeGenerateChirurgie() {
            let d = new Date()
            this.chirurgie_filename = 'Liste_Chirurgies_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        importExcelFile(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitChirurgie'

            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);
            
        },
    }
}


